import React from 'react';
import qs from 'qs';
import { apiNames } from 'project/general';
import { getApiUrlByName } from 'project/helpers';
import { baseApi } from 'project/api';
import { AccountOrdersLayout } from './account-orders-layout';

const PROFILE_ORDERS = getApiUrlByName(apiNames.PROFILE_ORDERS);

export default class AccountOrdersController extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            count: 0,
            products: null,
            pagination: {
                current: 1,
            },
            pager: null,
        };
    }

    componentDidMount() {
        this.fetchOrders();
    }

    fetchOrders = () => {
        const queryString = qs.stringify({
            page: this.state.pagination.current,
        });

        const url = PROFILE_ORDERS + '?' + queryString;

        baseApi
            .get(url)
            .then((res) => {
                if (!res.data.success) return;

                const { data } = res.data;

                this.setState({
                    count: data.count,
                    products: data.items,
                    pager: data.pager,
                });
            })
            .catch((err) => {
                console.log(err);
            });
    };

    selectPage = (pageIndex) => {
        this.setState({
            pagination: {
                current: pageIndex,
            }
        }, this.fetchOrders);
    };

    render() {
        return (
            <AccountOrdersLayout
                count={this.state.count}
                products={this.state.products}
                pager={this.state.pager}
                selectPage={this.selectPage}
                noOrderMessage={this.props.noOrderMessage}
            />
        );
    }
}
